import React, { ReactNode, useContext, useEffect, useState } from 'react';

import DecommissioningReportContext from '@totem/components/salesOrders/decommissioning/DecommissioningReportContext';
import { NotOnContractItems } from '@totem/components/salesOrders/decommissioning/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { SALES_ORDERS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const DecommissioningReportContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);

  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [reportData, setReportData] = useState<NotOnContractItems>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>('');

  useEffect(() => {
    if (!refreshData) {
      return;
    }

    setRefreshData(false);

    setLoading(true);

    fetch(`${SALES_ORDERS_ENDPOINT}/decommissioning`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: NotOnContractItems) => {
        const data = result ?? [];
        setReportData(data);

        setTotalRecords(data.length);
      })
      .then(() => setLoading(false));
  }, [refreshData, getApiToken]);

  return (
    <DecommissioningReportContext.Provider
      value={{
        loading,
        reportData,
        totalRecords,
        searchText,
        setSearchText,
        refetch: () => setRefreshData(true),
      }}
    >
      {children}
    </DecommissioningReportContext.Provider>
  );
};

export default DecommissioningReportContainer;
